import jQuery from 'jquery';
import Flickity from 'flickity';
import Viewport from './Viewport';

// Register our jquery version with Flickity.
Flickity.setJQuery(jQuery);

const sliderConfig = {
  wrapAround: true,
  groupCells: true,
  prevNextButtons: false,
};

export default class FlickityHomeStats {
  constructor(element) {
    this.element = element;
    this.$element = jQuery(element);

    // Sanity check for slider functionality.
    if (this.shouldBuildSlider) {
      Flickity.setJQuery(jQuery);
      this.viewport = new Viewport();
      this.viewport.onChange(this.update.bind(this));
      this.viewport.update();
      this.update();
    }

    // set component ready
    this.ready();
  }

  update() {
    this.buildSlider();
  }

  buildSlider() {
    if (!this.isSlider) {
      if (jQuery(window).width() >= 768) {
        sliderConfig.groupCells = true;
      } else {
        sliderConfig.groupCells = undefined;
      }
      this.slider = new Flickity(this.sliderElement, sliderConfig);
      this.isSlider = true;
    }
  }

  ready() {
    this.$element.addClass('ready');
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.node-content ul');
  }

  get slides() {
    return this.sliderElement.childNodes;
  }
}
